import CancelCircleIcon from '@/components/icons/CancelCircleIcon';
import CheckmarkCircle_02_Icon from '@/components/icons/CheckmarkCircle_02_Icon';
import DashboardCircleIconSolid from '@/components/icons/DashboardCircleIconSolid';
import Door_01_IconSolid from '@/components/icons/Door_01_IconSolid';
import MoneyReceiveCircleIcon from '@/components/icons/MoneyReceiveCircleIcon';
import MoneySendCircleIcon from '@/components/icons/MoneySendCircleIcon';
import { TransactionSign, TransactionType } from '@/features/transactions/types/transactions-dto';

const getTypeConfig = (type: TransactionType) => {
    switch (type) {
        case TransactionType.Property:
            return {
                label: 'main.transactions.type.property',
                icon: Door_01_IconSolid,
                iconStyles: 'fill-success-1000',
                colorClass: 'bg-success-100 fill-success-1000',
            };
        case TransactionType.OtherServices:
            return {
                label: 'main.transactions.type.otherServices',
                icon: DashboardCircleIconSolid,
                iconStyles: 'fill-info-1000',
                colorClass: 'bg-info-100 fill-info-1000',
            };
    }
};

const getFeeConfig = (sign: TransactionSign) => {
    switch (sign) {
        case TransactionSign.Minus:
            return {
                label: 'main.transactions.fee.charge',
                icon: MoneySendCircleIcon,
                iconStyles: 'fill-error-1000',
            };
        case TransactionSign.Plus:
            return {
                label: 'main.transactions.fee.payment',
                icon: MoneyReceiveCircleIcon,
                iconStyles: 'stroke-success-1000',
            };
    }
};

const getDeductionConfig = (sign: boolean) => {
    switch (sign) {
        case true:
            return {
                icon: CheckmarkCircle_02_Icon,
                iconStyles: 'fill-success-1000',
            };
        case false:
            return {
                icon: CancelCircleIcon,
                iconStyles: 'stroke-error-1000',
            };
    }
};

export const TransactionsUtils = {
    getTypeConfig,
    getFeeConfig,
    getDeductionConfig
};
